import permissions from './permission-list'

export default [
  {
    path: '/permissions',
    name: 'permissions',
    component: () => import('@/views/permissions/index.vue'),
    meta: {
      pageTitle: 'Daftar Permission',
      resource: permissions.permission,
      action: 'read',
      navActiveLink: 'permissions',
      breadcrumb: [
        {
          text: 'Daftar Permission',
          active: true,
        },
      ],
    },
  },
  {
    path: '/permissions/create',
    name: 'permissions-create',
    component: () => import('@/views/permissions/create.vue'),
    meta: {
      pageTitle: 'Buat Permission',
      resource: permissions.permission,
      action: 'manage',
      navActiveLink: 'permissions',
      breadcrumb: [
        {
          text: 'Permission',
          active: false,
          to: { path: '/permissions' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/permissions/:id/edit',
    name: 'permissions-edit',
    component: () => import('@/views/permissions/edit.vue'),
    meta: {
      pageTitle: 'Edit Permission',
      resource: permissions.permission,
      action: 'manage',
      navActiveLink: 'permissions',
      breadcrumb: [
        {
          text: 'Permission',
          active: false,
          to: { path: '/permissions' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
